/** Sidebar labels for the signed-in navigation. They also title the pages that aren't built yet. */
export const navCopy = {
  overview: 'Overview',
  tasks: 'Tasks',
  patients: 'Patients',
  prescribers: 'Prescribers',
  resources: 'Resources',
  settings: 'Settings',
} as const;
